import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield (hash oninput=this.oninput isDisabled=this.isDisabled)}}\n",{ moduleName: "client-portal/components/shared/auto-numeric.hbs" })